export default class ProductService {
  constructor($http, Upload) {
    'ngInject';

    this.$http = $http;
    this.Upload = Upload;
  }

  search(query) {
    return this.$http.get('/odata/ProductOData', {
      params: {
        $select: 'ProductId, ProductName',
        $top: query.take,
        ...query.page && { $skip: query.calculateSkip() },
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }

  searchProductsByName(name) {
    return this.$http.get(`/api/product/search_by_name?name=${name}`);
  }

  searchProductsByNameForCopy(name, isTreat) {
    return this.$http.get(`/api/product/search_by_name_for_copy?name=${name}&isTreat=${isTreat}`);
  }

  getProduct(id) {
    return this.$http.get(`/api/product/${id}`);
  }

  create(product) {
    return this.$http.post('/api/product/', product);
  }

  update(product) {
    return this.$http.put(`/api/product/${product.ProductId}`, product);
  }

  uploadLabel(productId, label) {
    return this.Upload.upload({
      url: `/api/product_label/${productId}`,
      data: {
        label
      }
    });
  }

  getLabel(id) {
    return this.$http.get(`/api/product_label/${id}`);
  }

  getLabelDetails(id) {
    return this.$http.get(`/api/product_label/${id}/request`);
  }

  getAdministrationUnits() {
    return this.$http.get('/api/product/container_types');
  }

  getAdministrationUnitsForSupplements() {
    return this.$http.get('/api/product/valid_container_types_for_supplements');
  }

  getAdministrationUnitsForTreats() {
    return this.$http.get('/api/product/valid_container_types_for_treats');
  }

  getFrequencies() {
    return this.$http.get('/api/product/get_frequency_type');
  }

  getPlantParts() {
    return this.$http.get('/api/product/get_plant_part');
  }

  getWeightUnits() {
    return this.$http.get('/api/product/get_weight_unit');
  }

  getHerbRatioFrom() {
    return this.$http.get('/api/product/get_herb_ratio_from');
  }

  getHerbRatioTo() {
    return this.$http.get('/api/product/get_herb_ratio_to');
  }

  getHerbForms() {
    return this.$http.get('/api/product/get_herb_forms');
  }

  signOff(productId, signature) {
    return this.$http.post(`/api/product/${productId}/sign`, {
      productId,
      signature
    });
  }

  getUnitsDisplay(product) {
    if (product.ProductForm) {
      if (product.ProductForm.indexOf('(s)') !== -1) {
        return product.ProductForm.toLowerCase();
      }
      return `${product.ProductForm.toLowerCase()}s`;
    }

    return 'units';
  }

  copyProduct(copyToProduct, copyFromProduct, copyAreas) {
    let copiedProduct = {
      ...copyToProduct,
      Signature: null,
      SignDate: null
    };

    for (let i = 0; i < copyAreas.length; i += 1) {
      if (copyAreas[i] === ('Product Information')) {
        copiedProduct = {
          ...copiedProduct,
          ...this.copyInformation(copyFromProduct)
        };
      } if (copyAreas[i] === ('Administrations')) {
        copiedProduct = {
          ...copiedProduct,
          ...this.copyAdministrations(copyFromProduct)
        };
      } if (copyAreas[i] === ('Product Ingredients')) {
        copiedProduct = {
          ...copiedProduct,
          ...this.copyIngredients(copyFromProduct)
        };
      }
      // if (copyAreas[i] === ('Usage Data')) {
      //   copiedProduct = {
      //     ...copiedProduct,
      //     ...this.copyUsageData(copyFromProduct)
      //   };
      // }
    }

    return copiedProduct;
  }

  copyInformation(product) {
    return {
      ProductCategoryIds: product.ProductCategoryIds,
      ProductName: product.ProductName,
      SKU: product.SKU,
      // make them supply a new date for the new version/reformulation  DateIntroduced: product.DateIntroduced,
      ProductForm: product.ProductForm,
      UnitPerContainer: product.UnitPerContainer,
      WarningNote: product.WarningNote,
      FeedingNote: product.FeedingNote,
      HasLoading: product.HasLoading,
      UPC: product.UPC,
      TakeAsNeeded: product.TakeAsNeeded,
      IsBulkQty: product.IsBulkQty,
      IsSample: product.IsSample,
      IsTreat: product.IsTreat
    };
  }

  copyAdministrations(product) {
    product.tblDoses = product.tblDoses || [];

    // eslint-disable-next-line no-restricted-syntax
    for (const u of product.tblDoses) {
      u.DoseId = 0;
      u.ProductId = 0;
    }

    return {
      tblDoses: product.tblDoses || []
    };
  }

  copyIngredients(product) {
    product.tblProduct_UserIngredient = product.tblProduct_UserIngredient || [];

    // eslint-disable-next-line no-restricted-syntax
    for (const u of product.tblProduct_UserIngredient) {
      u.Id = 0;
      u.ProductId = 0;
    }

    return {
      tblProduct_UserIngredient: product.tblProduct_UserIngredient
    };
  }

  // copyUsageData(product) {
  //   product.tblUsages = product.tblUsages || [];

  //   // eslint-disable-next-line no-restricted-syntax
  //   for (const u of product.tblUsages) {
  //     u.UsageId = 0;
  //     u.ProductId = 0;
  //   }

  //   return {
  //     tblUsages: product.tblUsages
  //   };
  // }

  transformUsages(productId, dateFirstSold, usages) {
    if (!dateFirstSold || !usages) {
      return [];
    }

    const validUsages = usages
      .filter(u => u.UsageYear >= dateFirstSold.getFullYear());

    const curYear = new Date().getFullYear();
    for (let i = dateFirstSold.getFullYear(); i <= curYear; i += 1) {
      if (validUsages.some(u => u.UsageYear === i) === false) {
        validUsages.push({
          Encry: false,
          ProductId: productId || 0,
          Q1: null,
          Q2: null,
          Q3: null,
          Q4: null,
          UsageId: 0,
          UsageYear: i
        });
      }
    }

    return [
      ...validUsages.sort((a, b) => (a.UsageYear - b.UsageYear))
    ];
  }

  // TODO: Refactor to OData call
  getCategories() {
    return this.$http.get('/api/product_category/all');
  }

  delete(id) {
    return this.$http.delete(`/api/product/${id}`);
  }
}



// WEBPACK FOOTER //
// ./services/product.service.js